<template>
    <el-dialog class="el-dialogs" title="批量排序" width="40%" :close-on-click-modal="false"
               :visible.sync="visible">
        <div class="tips">
            <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
            已选择{{ dataListSelect.length }}项数据
        </div>
        <el-form size="small" :inline="true" ref="searchForm" :model="searchForm" :rules="rules" label-width="100px" class="magTop">
            <el-form-item label="批量排序：" prop="sequence">
                <el-input-number v-model="searchForm.sequence" controls-position="right" @change="setBorrowDays('sequence')" :min="0" label="请输入排序"></el-input-number>
                <div class="prompt">新设置的排序号将覆盖原来的排序号，设置后立即生效</div>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">关闭</el-button>
            <el-button type="primary" size="small" @click="sureData()" v-no-more-click>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "batchSorting",
    data(){
        return{
            visible:false,
            dataListSelect:[],
            searchForm:{
                sequence:0,
            },
            rules:{
                sequence: [
                    { required: true, message: '请输入排序', trigger: 'blur' },
                ],
            },
            maxSort:0,
        }
    },

    methods:{
        init(selectList){
            this.visible = true
            this.dataListSelect = selectList
            this.searchForm.sequence = 0
            this.getOthers()
        },

        getOthers(){
            this.$axios(this.api.user.configKey + 'publish_sequence').then(data => {
                if (data && data.status) {
                    this.maxSort = data.data
                }
            })
        },

        //只能输入大于0的正整数
        setBorrowDays(formName) {
            let setValue = this.searchForm[formName] + ''
            setValue = setValue.replace(/[^0-9]/g, "")
            if (setValue * 1 > this.maxSort) {
                setValue = this.maxSort
            }
            this.$nextTick(()=>{
                this.searchForm[formName] = setValue
            })
        },

        sureData(){
            this.$refs['searchForm'].validate((valid) => {
                if (valid) {
                    this.$axios(this.api.metadata.batchUpdateDataBySequence, {
                        ids:this.dataListSelect,
                        ...this.searchForm,
                    }, 'post').then(data => {
                        if (data.status) {
                            this.$message.success('设置成功')
                            this.$emit('refreshData')
                            this.visible = false
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            })
        },
    },
}
</script>

<style scoped>
.tips {
    padding: 4px;

    .el-icon-info {
        margin-right: 6px;
    }
}

.magTop{
    margin-top: 20px;
}

.prompt{
    font-size: 12px;
    color: #E6AAAA;
}
</style>